module.exports = __webpack_public_path__ + "img/thumbnail_NorthIslandBrownKiwi_j_leucistic.152c68f2.png";